import { render } from "./CustomerCompanyCreditAndAccountingPeriodForm.vue?vue&type=template&id=b1857184&scoped=true&ts=true"
import script from "./CustomerCompanyCreditAndAccountingPeriodForm.vue?vue&type=script&lang=ts"
export * from "./CustomerCompanyCreditAndAccountingPeriodForm.vue?vue&type=script&lang=ts"

import "./CustomerCompanyCreditAndAccountingPeriodForm.vue?vue&type=style&index=0&id=b1857184&scoped=true&lang=css"

import exportComponent from "D:\\workspace\\com.xiansheng\\MiezzGitPull\\Miezz\\Miezz.Web.Entry\\client\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b1857184"]])

export default __exports__